import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { iifSubscriptionLicenseValid } from '@core/helpers/license/license.helper';
import { LicenseService } from '@core/services/license/license.service';
import { RoutePath } from '@shared/route-path.enum';
import { map } from 'rxjs';

export const subscriptionLicenseActiveGuard = (_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) => {
	const licenseService = inject(LicenseService);
	const router = inject(Router);
	return licenseService.license$.pipe(
		map((license) => {
			if (iifSubscriptionLicenseValid(license, true)) {
				return true;
			}
			router.navigate([RoutePath.LICENSE]);
			return false;
		})
	);
};
